import React from "react";

const BannerImage = (props) => {
  const { conferenceDocuments, alt } = props;

  return (
    <img
      src={conferenceDocuments}
      className="d-block w-100"
      alt={alt}
    />
  );
};

export default BannerImage;
